"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LexiWallet = void 0;
const encrypt_1 = require("../lib/encrypt");
const encryption_key_box_1 = __importDefault(require("../lib/encryption_key_box"));
const key_1 = require("../lib/key");
class LexiWallet {
    constructor(wallet, myDID, options = {}) {
        this.wallet = wallet;
        this.myDID = myDID;
        this.options = options;
        this.encryptionKeyBox = new encryption_key_box_1.default();
    }
    async generateKeyForSigning() {
        await (0, key_1.generateX25519KeyPairFromSignature)(this.wallet, this.options.publicSigningString || key_1.singleUsePublicString, this.encryptionKeyBox);
    }
    decrypt(cyphertext) {
        return (0, encrypt_1.decryptJWEWithLexi)(JSON.parse(cyphertext), this.wallet, this.options.publicSigningString || key_1.singleUsePublicString, this.encryptionKeyBox);
    }
    encrypt(plaintext, did) {
        return (0, encrypt_1.encryptForDid)(plaintext, did, this.options.resolve).then(JSON.stringify);
    }
    encryptForMe(plaintext) {
        return (0, encrypt_1.encryptForMe)(plaintext, this.myDID, this.wallet, this.options, this.encryptionKeyBox).then(JSON.stringify);
    }
    signMessage(message) {
        return this.wallet.signMessage(message);
    }
}
exports.LexiWallet = LexiWallet;
